import { EstimationColumn as ExcelColumn } from "../../common/excelColumns";
import { Column } from "../../ExportDataToExcel";
import excelColumnWithOrder from "../../common/excelColumns";
import { Month } from "../../admin/getEstimationMonths";

export default (months: Month[]): Column[] =>
  excelColumnWithOrder.map(
    (key: ExcelColumn): Column => {
      if (key === "category") {
        return {
          label: "Category",
          value: "categories",
        };
      } else if (key === "name") {
        return {
          label: "Name",
          value: "articleName",
        };
      } else if (key === "season") {
        return {
          label: "Season",
          value: "season",
        };
      } else if (key === "articleId") {
        return {
          label: "Article ID",
          value: "articleId",
        };
      } else if (key === "sku") {
        return {
          label: "SKU",
          value: "sku",
        };
      } else if (key === "ean") {
        return {
          label: "EAN",
          value: "ean",
        };
      } else if (key === "eanPack") {
        return {
          label: "EAN Pack",
          value: "eanPack",
        };
      } else if (key === "isCollab") {
        return {
          label: "Is Collab",
          value: "isCollab",
        };
      } else if (key === "collectionSegment") {
        return {
          label: "Collection Segment",
          value: "collectionSegment",
        };
      } else if (key === "assortmentSegment") {
        return {
          label: "Assortment Segment",
          value: "assortmentSegment",
        };
      } else if (key === "variantCode") {
        return {
          label: "Variant code",
          value: "variantCode",
        };
      } else if (key === "size") {
        return {
          label: "Size",
          value: "size",
        };
      } else if (key === "price") {
        return {
          label: "Price €",
          value: "price",
        };
      } else if (key === "packageSize") {
        return {
          label: "Package size",
          value: "packageSize",
        };
      } else if (key === "month0") {
        return {
          label: createMonthLabel(months[0]),
          value: "estimationMonth1",
        };
      } else if (key === "month1") {
        return {
          label: createMonthLabel(months[1]),
          value: "estimationMonth2",
        };
      } else if (key === "month2") {
        return {
          label: createMonthLabel(months[2]),
          value: "estimationMonth3",
        };
      } else {
        throw Error("Not known column " + key);
      }
    }
  );

export const createMonthLabel = (month: Month): string =>
  month.year + "/" + month.month;



// WEBPACK FOOTER //
// ./src/view/estimations/export/createMapper.ts